import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaPlus } from 'react-icons/fa';
import { showModal } from '../../components/generic/Modal';
import { ContentLayout } from '../../components/layouts/ContentLayout';
import { useUsersFilterQuery } from '../../graphql/hooks/useUsersQuery';
import { useUsersFilter } from '../../hooks/useUsersFilter';
import { UserInviteModal } from './UserInviteModal';
import { UsersFilterControls } from './UsersFilterControls';
import { UsersTable } from './UsersTable';

export const Users = () => {
  const filter = useUsersFilter();

  const { isLoading, error, users, refetch, pagination } = useUsersFilterQuery(filter);

  return (
    <ContentLayout
      headerContent={
        <ChakraV3.HStack align='start'>
          <ChakraV3.Heading size='3xl' fontWeight='bold'>
            Users
          </ChakraV3.Heading>
          <ChakraV3.Spacer />
          <ChakraV3.Button
            colorPalette='brand'
            size='sm'
            onClick={() => showModal(UserInviteModal)}
          >
            <FaPlus />
            Create user
          </ChakraV3.Button>
        </ChakraV3.HStack>
      }
    >
      <ChakraV3.Stack gap={4} px={6}>
        <UsersFilterControls filter={filter} />
        <UsersTable
          error={error}
          isLoading={isLoading}
          users={users}
          refetch={refetch}
          pagination={pagination}
        />
      </ChakraV3.Stack>
    </ContentLayout>
  );
};
